@use '@lib/assets/styles/main.scss' as *;

.popoverBody {
  margin: -8px -16px;
}

.menuItemClassName {
  padding-left: 16px;
  padding-right: 16px;
}
